// extracted by mini-css-extract-plugin
export default {"Button":"e1LqgwvwOdlmxs64EfpD"};